import HTTPService from './service';

const service = new HTTPService();

export default service;
export * from './httpService.types';
